import {Product} from '../mappers/product.mapper';
import {ProductRepository} from '../repository/ProductRepository';
import {Pagination} from '../../../Data/types/BaseResponse';
import {PAGINATION_CONFIG} from '../../../constants/appConfig';

export class GetAllProductsUseCase {
  constructor (private productRepository: ProductRepository) {}

  async execute (page = 1, limit: number = PAGINATION_CONFIG.DEFAULT_PAGE_SIZE): Promise<{ items: Product[]; pagination?: Pagination }> {
    return this.productRepository.getAll(page, limit);
  }
}
